import { render, staticRenderFns } from "./PrintManagement.vue?vue&type=template&id=64389de8&scoped=true&"
import script from "./PrintManagement.vue?vue&type=script&lang=ts&"
export * from "./PrintManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64389de8",
  null
  
)

export default component.exports